module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"planEnded":"У вас закончились отклики.","planEndedText":"Вы можете выбрать один из подходящих вам тарифов.","more":"Подробнее"}}')
  delete Component.options._Ctor
}
